import { useContext, useEffect } from 'react';
import { useAppDispatch } from 'hooks/redux';
import { toggleOpenFullscreenAction } from 'store/actions/map';
import MapContext from '../MapContext';
import { FullScreen } from '../../../../node_modules/ol/control';

const FullScreenControl = () => {
  const { map } = useContext(MapContext);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!map) return;

    let fullScreenControl = new FullScreen({
      source: 'fs-box',
      target: 'fs-btn',
      className: 'ol-fs',
    });

    map.controls.push(fullScreenControl);

    fullScreenControl.on('leavefullscreen', (e) => {
      dispatch(toggleOpenFullscreenAction(false));
    });

    return () => {
      map.controls.remove(fullScreenControl);
      fullScreenControl.un('leavefullscreen', (e) => {
        dispatch(toggleOpenFullscreenAction(false));
      });
    };
  }, [map]);

  return null;
};

export default FullScreenControl;
